//angular.module("NumbersEditor").filter('sportCodeDesc', function () {
//    return function (input) {
//        switch (input) {
//            case "49":
//                return "49";
//            case "IL":
//                return "Irish Lottery";
//            default:
//                return input;
//        }
//    }
//});